import { render, staticRenderFns } from "./SettingsNotificationChannels.vue?vue&type=template&id=0bd3890e&"
import script from "./SettingsNotificationChannels.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationChannels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports